window.addEventListener('load', function(e) {

	// target the right page
	var faqs = document.querySelectorAll('ul.faq');
	if (!faqs.length) {
		return;
	}

	init();

	/**
	 * Initializes the page
	 */
	function init() {
		addHandlers();
	}

	/**
	 * Sets event listeners for the page
	 */
	function addHandlers() {
		var buttons = [];
		Array.prototype.forEach.call(faqs, function(faq) {
			var btns = faq.querySelectorAll('.faq-button');
			Array.prototype.forEach.call(btns, function(btn) {
				buttons.push(btn);
			});
		});

		buttons.forEach(function(button) {
			button.addEventListener('click', onClickFaqButton);
		})
	}

	function onClickFaqButton(e) {
		var button = e.target;
		var answer = button.parentNode.parentNode.querySelector('.faq-answer');
		var isPressed = button.getAttribute('aria-pressed') !== 'true';
		button.setAttribute('aria-pressed', isPressed ? 'true' : 'false');
		button.setAttribute('aria-expanded', isPressed ? 'true' : 'false');
		answer.style.display = isPressed ? 'block' : 'none';
	}
});
